<!--Banner-->
<div class="d-lg-block d-none mb-4">
  <fgb-banner [title]="'account.activity.page.title' | translate" class="d-lg-flex d-none"></fgb-banner>
</div>

<fgb-mobile-page-header
  pageTitle="account.page.title"
  [showFooter]="true"
  [showQr]="true"
  [backButtonLink]="'/'"
></fgb-mobile-page-header>

<div class="mt-lg-3">
  <fgb-account-nav></fgb-account-nav>
</div>

<div class="container mt-4">
  <div class="points-history">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </div>
</div>
